module.exports = __webpack_public_path__ + "img/login_bg_new2.b61be3f9.png";